import React from "react";
import StudioInfoModule from "./StudioInfoModule";
import StudioInfoSagas from "./redux/studioInfoSagas";
import StudioInfoReducer from "./redux/studioInfoReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Studio Info",
  moduleList: [
    {
      Component: StudioInfoModule,
      moduleName: "studioInfo",
      saga: StudioInfoSagas(),
      reducer: StudioInfoReducer
    }
  ],
  hideConfigurator: true
};

const StudionInfoPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default StudionInfoPage;
